<template>
  <div id="header-menu" v-if=isDispMenu>
    <ul id="header_upside">
      <li class="new">
        <span class="head_btn container" v-on:mouseover="isOnNew(true)" v-on:mouseleave="isOnNew(false)" @click="$emit('onNew')" style="width: 80px">
          <i>
            <img :src="imgNew" alt="new" width="24px" height="auto" title="新規作成(Ctrl+Alt+N)">
          </i>
            新規作成
        </span>
      </li>
      <li class="save">
        <span class="head_btn container" v-on:mouseover="canSavePlan ? isOnSave(true) : null" v-on:mouseleave="canSavePlan ? isOnSave(false) : null" @click="canSavePlan ? $emit('onSave') : null" style="width: 56px">
          <i>
            <img :src="imgSave" alt="regist" width="24px" height="auto" title="保存(Ctrl+S)">
            <!-- <img :src="imgSave" alt="regist" width="24px" height="auto" title="登録(Ctrl+S)"> -->
          </i>
            保存
        </span>
      </li>
      <li class="icon">
        <span v-on:mouseover="isOnPrev(true)" v-on:mouseleave="isOnPrev(false)" class="head_btn container" @click="$emit('undo')">
            <i>
              <img :src="imgPrev" alt="undo" width="24px" height="auto" title="元に戻す(Ctrl+Z)">
            </i>
        </span>
      </li>
      <li class="icon">
        <span class="head_btn container" v-on:mouseover="isOnNext(true)" v-on:mouseleave="isOnNext(false)" @click="$emit('redo')">
          <i>
            <img :src="imgNext" alt="redo" width="24px" height="auto" title="やり直し(Ctrl+Y)">
          </i>
        </span>
      </li>
      <li class="icon">
        <span class="head_btn container" v-on:mouseover="isOnTrash(true)" v-on:mouseleave="isOnTrash(false)" @click="$emit('deleteSpace')">
          <i>
            <img :src="imgTrash" alt="delete" width="24px" height="auto" title="削除(Delete)">
          </i>
        </span>
      </li>
      <li class="icon">
        <span class="head_btn container" v-on:mouseover="isOnSetCell(true)" v-on:mouseleave="isOnSetCell(false)" @click="$emit('showSetCellRatioModal')" v-bind:class="{icon_disabled: !isActiveSetCell}">
          <i>
            <img :src="imgSetCell" alt="cellSetting" width="24px" height="auto" title="セル比率設定(Ctrl+Shift+C)">
          </i>
        </span>
      </li>
      <li class="icon">
        <span v-if="fileData && fileData.topSpaceModel"  v-on:mouseover="isOnColor(true)" v-on:mouseleave="isOnColor(false)" class="head_btn container" @click="$emit('showEditFileModal',  fileData.topSpaceModel.spaceObjectType, fileData.spaceJoincd)">
          <i>
            <img :src="imgColor" alt="setting" width="24px" height="auto" title="設定">
          </i>
        </span>
        <span v-else class="head_btn container"   @click="$emit('showEditFileModal' )" v-on:mouseover="isOnColor(true)" v-on:mouseleave="isOnColor(false)">
          <i>
            <img :src="imgColor" alt="setting" width="24px" height="auto" title="設定">
          </i>
        </span>
      </li>
      <li class="icon">
        <!--  サイズ設定 -->
        <span v-on:mouseover="isOnSize(true)" v-on:mouseleave="isOnSize(false)" @click="$emit('showSetSizeModal')" v-bind:class="{icon_disabled: !isCabinetSelected()}">
          <i>
            <img :src="imgSize" alt="sizeSetting" width="24px" height="auto" title="サイズ設定">
          </i>
        </span>
      </li>
      <li class="icon">
        <span v-on:mouseover="isOnResize(true)" v-on:mouseleave="isOnResize(false)" @click="$emit('resizeSpacesEven')" v-bind:class="{icon_disabled: !isCabinetMultiSelected}">
          <!--  水平方向に均等リサイズ -->
          <i>
            <img :src="imgResize" alt="resize" width="24px" height="auto" title="水平方向に均等リサイズ">
          </i>
        </span>
      </li>
      <li class="icon">
        <span v-on:mouseover="isOnSetPlan(true)" v-on:mouseleave="isOnSetPlan(false)" @click="$emit('addSetPlan')" v-bind:class="{icon_disabled: !isCabinetMultiSelected}">
          <!-- セットプランに追加 -->
          <i>
            <img :src="imgSetPlan" alt="domans" width="24px" height="auto" title="セットプランに追加">
          </i>
        </span>
      </li>
      <li class="icon">
        <span v-on:mouseover="isOnKabuse(true)" v-on:mouseleave="isOnKabuse(false)" @click="$emit('showSetDoorWrapModal')" v-bind:class="{icon_disabled: !isDoorSelected()}">
          <!--  かぶせ設定 -->
          <i>
            <img :src="imgKabuse" alt="kabuse" width="24px" height="auto" title="かぶせ設定">
          </i>
        </span>
      </li>
      <li class="icon">
        <span v-on:mouseover="isOnReload(true)" v-on:mouseleave="isOnReload(false)" @click="$emit('getEditingFileDataWithLoadingModal')" v-bind:class="{icon_disabled: opeMode.autoUpdate}">
          <!--  価格/加工更新 -->
          <i>
            <img :src="imgReload" alt="reload" width="24px" height="auto" title="価格/加工更新">
          </i>
        </span>
      </li>
      <li class="label">
        <span>選択対象 : </span>
      </li>
      <li class="icon">
        <span @click="opeMode.selectMode=modeCabine; $emit('onSelectModeChanged')" v-bind:class="{icon_disabled: opeMode.selectObject!==objectUnit}">
          <i v-show="opeMode.selectMode === modeCabine">
            <img :src="getImage('pages/planning/ic_sel_box_on.svg')" alt="mode:cabine" width="24px" height="auto" title="スケルトン・固定棚・カウンター・パネル選択モード">
          </i>
          <i v-show="opeMode.selectMode !== modeCabine">
            <img :src="getImage('pages/planning/ic_sel_box_off.svg')" alt="mode:cabine" width="24px" height="auto" title="スケルトン・固定棚・カウンター・パネル選択モード">
          </i>
        </span>
      </li>
      <li class="icon">
        <span @click="opeMode.selectMode=modeDoorInfill;  $emit('onSelectModeChanged')" v-bind:class="{icon_disabled: opeMode.selectObject!==objectUnit}">
          <i v-show="opeMode.selectMode === modeDoorInfill">
            <img :src="getImage('pages/planning/ic_sel_dr_on.svg')" alt="mode:door" width="24px" height="auto" title="引出し ・可動棚・扉選択モード">
          </i>
          <i v-show="opeMode.selectMode !== modeDoorInfill">
            <img :src="getImage('pages/planning/ic_sel_dr_off.svg')" alt="mode:door" width="24px" height="auto" title="引出し ・可動棚・扉選択モード">
          </i>
        </span>
      </li>
      <li class="label">
        <span>モードON/OFF : </span>
      </li>
      <li class="icon">
        <span @click="clickDistDisp(); $emit('changeFaceDistanceMode', true)">
          <i v-show="opeMode.faceDistanceDisp">
            <img :src="getImage('pages/planning/ic_dist_on.svg')" width="24px" height="auto" title="面間距離を表示">
          </i>
          <i v-show="!opeMode.faceDistanceDisp">
            <img :src="getImage('pages/planning/ic_dist_off.svg')" width="24px" height="auto" title="面間距離を表示">
          </i>
        </span>
      </li>
      <li class="icon">
        <span @click="clickDistMv(); $emit('changeFaceDistanceMode', false)">
          <i v-show="opeMode.faceDistanceMove">
            <img :src="getImage('pages/planning/ic_distmv_on.svg')" width="24px" height="auto" title="面間距離を指定して移動">
          </i>
          <i v-show="!opeMode.faceDistanceMove">
            <img :src="getImage('pages/planning/ic_distmv_off.svg')" width="24px" height="auto" title="面間距離を指定して移動">
          </i>
        </span>
      </li>
      <li span class="partition">
        <span><i></i></span>
      </li>
      <li class="icon">
        <span @click="clickRectSelect(); $emit('setOpeMode')">
          <i v-show="opeMode.rectSelect">
            <img :src="getImage('pages/planning/ic_sel_sq_on.svg')" width="24px" height="auto" title="矩形選択モード ">
          </i>
          <i v-show="!opeMode.rectSelect">
            <img :src="getImage('pages/planning/ic_sel_sq_off.svg')" width="24px" height="auto" title="矩形選択モード ">
          </i>
        </span>
      </li>
      <li span class="partition">
        <span><i></i></span>
      </li>
      <!-- 価格/加工自動更新モード -->
      <li class="icon">
        <span @click="$emit('changeAutoUpdateMode')">
          <i v-show="opeMode.autoUpdate">
            <img :src="getImage('pages/planning/ic_autoreload_on.svg')" width="24px" height="auto" title="自動更新モード ">
          </i>
          <i v-show="!opeMode.autoUpdate">
            <img :src="getImage('pages/planning/ic_autoreload_off.svg')" width="24px" height="auto" title="自動更新モード ">
          </i>
        </span>
      </li>
      <!-- 自動生成ボタン -->
      <li class="output">
        <a href="#" class="sheet" @click.prevent="canOutput ? $emit('onPreview') : null" v-bind:class="{img_disable: !isPreviewFile}">
          <img :src="imgSheet" alt="sheet" />
          <span>自動生成</span>
        </a>
      </li>
      <!-- 見積価格設定ボタン -->
      <li class="output">
        <a href="#" class="sheet" @click.prevent="$emit('showCostCustomModal')" v-bind:class="{img_disable: !isPreviewFile}">
          <span>見積価格設定</span>
        </a>
      </li>
      <li class="output" v-if="isOrder">
        <a href="#" class="sheet" @click.prevent="$emit('showProfitSettingModal')" v-bind:class="{img_disable: !isPreviewFile}">
          <span>プラン利益分配率設定</span>
        </a>
      </li>
      <li id=menu_toggle>
        <span>
          <i>
            <img :src="getImage('pages/planning/ic_menu_off.svg')" alt="toggle" width="24px" height="auto"  @click="$emit('onClickMenuToggle', false)">
          </i>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import * as App from '../../../utils/App'
import {OBJECT_TYPE, SELECT_MODE, PLANNING_TYPE} from '../../../constants/Type'

export default {
  name: 'HeaderMenu',
  components: {
  },
  props: {
    fileData: Object,
    isDispMenu: Boolean,
    opeMode: Object,
    isSpaceSelected: Boolean,
    isCabinetMultiSelected: Boolean,
    editCtrlSpaces: Array,
    editChildrenDoor: null,
    isPlan: null,
    isPreviewFile: null,
    isPlanning: Boolean,
    isActiveSetCell: Boolean
  },
  data () {
    return {
      // ステータス
      modeCabine: SELECT_MODE.CABINET.code,
      modeDoorInfill: SELECT_MODE.DOOR_DRAWER_INFILL.code,
      objectUnit: OBJECT_TYPE.UNIT.code,
      // 画像ファイル
      imgPrev: this.getImage('pages/planning/ic_preview_off.svg'),
      imgNext: this.getImage('pages/planning/ic_next_off.svg'),
      imgNew: this.getImage('pages/planning/ic_new_off.svg'),
      imgSave: this.getImage('pages/planning/ic_save_off.svg'),
      imgPreview: this.getImage('pages/planning/ic_sheet_off.svg'),
      imgTrash: this.getImage('pages/planning/ic_trash_off.svg'),
      imgSetCell: this.getImage('pages/planning/ic_setcell_off.svg'),
      imgColor: this.getImage('pages/planning/ic_color_off.svg'),
      imgSize: this.getImage('pages/planning/ic_setsize_off.svg'),
      imgResize: this.getImage('pages/planning/ic_dispos_h_off.svg'),
      imgSetPlan: this.getImage('pages/planning/ic_setplan_off.svg'),
      imgKabuse: this.getImage('pages/planning/ic_kabuse_off.svg'),
      imgReload: this.getImage('pages/planning/ic_reload_off.svg'),
      imgCabine: this.getImage('pages/planning/ic_sel_box_off.svg'),
      imgDoor: this.getImage('pages/planning/ic_sel_dr_off.svg'),
      imgUnit: this.getImage('pages/planning/ic_sel_ut_off.svg'),
      imgCell: this.getImage('pages/planning/ic_sel_cell_off.svg'),
      imgDistDisp: this.getImage('pages/planning/ic_dist_off.svg'),
      imgDistMv: this.getImage('pages/planning/ic_distmv_off.svg'),
      imgSheet: this.getImage('pages/planning/ic_sheet_sel.svg'),
      imgEstimate: this.getImage('print/ic_estimate_sel.svg'),
      imgBom: this.getImage('print/ic_output_sel.svg'),
      imgCG: this.getImage('print/ic_output_sel.svg')
    }
  },
  watch: {
  },
  computed: {
    // userOrderTypeで権限制御
    canSavePlan: function () {
      let user = App.getUserInfo()
      if (typeof user.userOrderType === 'string') {
        let userOrderType = user.userOrderType.split('|')
        return userOrderType.includes('1') || userOrderType.includes('91')
      }
    },
    // userOrderTypeで権限制御
    canOutput: function () {
      let user = App.getUserInfo()
      if (typeof user.userOrderType === 'string') {
        let codes = ['1', '2', '3', '4', '91']
        let userOrderType = user.userOrderType.split('|')
        return codes.some((code) => userOrderType.includes(code))
      }
    },
    isOrder: function () {
      let user = App.getUserInfo()
      return user.corpId === 170
    }
  },
  methods: {
    onClickMenuToggle: function () {
      if (this.isOnMenuToggle) {
        this.isOnMenuToggle = false
      } else {
        this.isOnMenuToggle = true
      }
    },
    isOnPrev: function (on) {
      if (on) {
        this.imgPrev = this.getImage('pages/planning/ic_preview_on.svg')
      } else {
        this.imgPrev = this.getImage('pages/planning/ic_preview_off.svg')
      }
    },
    isOnNext: function (on) {
      if (on) {
        this.imgNext = this.getImage('pages/planning/ic_next_on.svg')
      } else {
        this.imgNext = this.getImage('pages/planning/ic_next_off.svg')
      }
    },
    isOnNew: function (on) {
      if (on) {
        this.imgNew = this.getImage('pages/planning/ic_new_on.svg')
      } else {
        this.imgNew = this.getImage('pages/planning/ic_new_off.svg')
      }
    },
    isOnSave: function (on) {
      if (on) {
        this.imgSave = this.getImage('pages/planning/ic_save_on.svg')
      } else {
        this.imgSave = this.getImage('pages/planning/ic_save_off.svg')
      }
    },
    isOnSheet: function (on) {
      if (on) {
        this.imgPreview = this.getImage('pages/planning/ic_sheet_on.svg')
      } else {
        this.imgPreview = this.getImage('pages/planning/ic_sheet_off.svg')
      }
    },
    isOnTrash: function (on) {
      if (on) {
        this.imgTrash = this.getImage('pages/planning/ic_trash_on.svg')
      } else {
        this.imgTrash = this.getImage('pages/planning/ic_trash_off.svg')
      }
    },
    isOnSetCell: function (on) {
      if (on) {
        this.imgSetCell = this.getImage('pages/planning/ic_setcell_on.svg')
      } else {
        this.imgSetCell = this.getImage('pages/planning/ic_setcell_off.svg')
      }
    },
    isOnColor: function (on) {
      if (on) {
        this.imgColor = this.getImage('pages/planning/ic_color_on.svg')
      } else {
        this.imgColor = this.getImage('pages/planning/ic_color_off.svg')
      }
    },
    isOnSize: function (on) {
      if (on) {
        this.imgSize = this.getImage('pages/planning/ic_setsize_on.svg')
      } else {
        this.imgSize = this.getImage('pages/planning/ic_setsize_off.svg')
      }
    },
    isOnResize: function (on) {
      if (on) {
        this.imgResize = this.getImage('pages/planning/ic_dispos_h_on.svg')
      } else {
        this.imgResize = this.getImage('pages/planning/ic_dispos_h_off.svg')
      }
    },
    isOnSetPlan: function (on) {
      if (on) {
        this.imgSetPlan = this.getImage('pages/planning/ic_setplan_on.svg')
      } else {
        this.imgSetPlan = this.getImage('pages/planning/ic_setplan_off.svg')
      }
    },
    isOnKabuse: function (on) {
      if (on) {
        this.imgKabuse = this.getImage('pages/planning/ic_kabuse_on.svg')
      } else {
        this.imgKabuse = this.getImage('pages/planning/ic_kabuse_off.svg')
      }
    },
    isOnReload: function (on) {
      if (on) {
        this.imgReload = this.getImage('pages/planning/ic_reload_on.svg')
      } else {
        this.imgReload = this.getImage('pages/planning/ic_reload_off.svg')
      }
    },
    clickRectSelect: function () {
      this.opeMode.rectSelect = !this.opeMode.rectSelect
    },
    clickDistDisp: function () {
      this.opeMode.faceDistanceDisp = !this.opeMode.faceDistanceDisp
    },
    clickDistMv: function () {
      this.opeMode.faceDistanceMove = !this.opeMode.faceDistanceMove
    },
    isDoorSelected: function () {
      return this.isSpaceSelected && this.opeMode.selectMode === SELECT_MODE.DOOR_DRAWER_INFILL.code &&
        this.opeMode.selectObject === OBJECT_TYPE.UNIT.code &&
        this.editCtrlSpaces.length > 0 &&
        this.editCtrlSpaces.filter(space => ![PLANNING_TYPE.UNIT_DOOR, PLANNING_TYPE.UNIT_DRAWER].includes(space.planningType)).length < 1
    },
    isCabinetSelected: function () {
      return this.isSpaceSelected && this.opeMode.selectMode === SELECT_MODE.CABINET.code &&
        this.opeMode.selectObject === OBJECT_TYPE.UNIT.code && this.editCtrlSpaces[0].planningType === PLANNING_TYPE.UNIT_SKELTON
    },
    getImage: function (image) {
      return App.getDarosResource(image)
    }
  },
  created: function () {
  },
  mounted: function () {
  },
  beforeDestroy: function () {
  }
}
</script>
<style src="../../../css/planning/planning.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/main/js/components/planning/parts/HeaderMenu.vue